import React from "react";

export const Header = () => {
  return (
    <div className=" w-full px-8 py-2 bg-white  flex justify-between border border-b-1 rounded-b-lg fixed shadow-xl z-40">
      <img
        className="w-72 rounded-3xl ml-9"
        src="
https://reecocefe1aea.b-cdn.net/wp-content/uploads/2022/09/Reecocefe-Logo.webp.bv.webp?bv_host=reecocefe.in"
        alt="LOGO"
      />
    </div>
  );
};
